// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3e4OM","delete":"styles_delete__3LcjQ","update":"styles_update__21vw8","add":"styles_add__2iufq"};